<template>
  <div class="m-content">
    <div class="right-area">
      <el-button v-if="productImg" class="danger" @click="ExportSavePdf()">生成图片</el-button>
      <el-button v-else class="danger" @click="BackReport()">返回报告</el-button>
    </div>
    <div id="demo">
      <template  v-if="productImg">
        <!-- 头像、个人信息，菜单导航 -->
        <div class="head-box">
          <div class="head-content">
            <div class="center-area">
              <p class="head-title">{{shengyaUser.studentName ? shengyaUser.studentName : shengyaUser.nickname}}</p>
              <p>{{shengyaUser.studentCollege}}</p>
              <p>{{shengyaUser.studentMajor}}</p>
            </div>
          </div>
          <ul class="nav-menu">
            <li :class="isCurrent[0]?'current':''" @click="goAnchor('#anchor-0')">生涯发展状况</li>
            <li :class="isCurrent[1]?'current':''" @click="goAnchor('#anchor-1')">自我剖析情况</li>
            <li :class="isCurrent[2]?'current':''" @click="goAnchor('#anchor-2')">生涯决策情况</li>
            <li :class="isCurrent[3]?'current':''" @click="goAnchor('#anchor-3')">未来努力方向</li>
          </ul>
        </div>
        <!-- 报告内容 -->
        <div class="r-content">
          <ReportDevelop :id="'anchor-0'" :content="result"></ReportDevelop>
          <ReportAnalysis :id="'anchor-1'" :content="result"></ReportAnalysis>
          <ReportCareerDecision :id="'anchor-2'" :content="result"></ReportCareerDecision>
          <ReportDirection :id="'anchor-3'" :content="result"></ReportDirection>
        </div>
      </template>
      <img v-else class="report-img" :src="dataUrl"/>
    </div>
    <div class="button-box">
      <button class="default-btn large-btn" @click="emitBackActivities">返回活动广场</button>
    </div>
    <!-- 弹出框提示 -->
    <div class="modal-box" v-if="show">
      <div class="modal-content">
        <p>点击确定继续生成图片，图片生成完毕，长按出现对应提示后，可保存至手机</p>
        <div class="btn-group" >
          <button class="default-btn" @click="cancleSave">取消</button>
          <button class="default-btn submit-btn" @click="exportSaveImg">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportDevelop from '@/page/ReportDevelop'
  import ReportAnalysis from '@/page/ReportAnalysis'
  import ReportCareerDecision from '@/page/ReportCareerDecision'
  import ReportDirection from '@/page/ReportDirection'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import qs from 'qs'
  import html2canvas from 'html2canvas'
  import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  name: 'PersonalReport',
  components: {
    ReportDevelop,
    ReportAnalysis,
    ReportCareerDecision,
    ReportDirection
  },
  data() {
    return{
      id:95,
      result:{},
      show:false,
      isCurrent:[true,false,false,false],
      abilityText:[{'title':'技术/专业人员','text':'成就导向是杰出的技术人员的一项常见特质，杰出的技术人员常以杰出的标准为标杆来衡量自己的表现与成果；技术人员常常需要有根据的说服他人，并且根据他人的预期来调整自己的说法；优秀的思考能力是技术“明星”身上的常见特质；主动性体现在技术人员在困难问题解决之前所展现的耐心或耐力，以及善于把握机会提早解决未来的问题；杰出的技术人员对自己的专业能力有自信，在自己的领域中喜欢困难的挑战，在专业工作上具有责任感；技术人员需要在做报告或和他人欧通时具备一定的对他人感受的敏感度；杰出技术人员对精准度和清晰度有较高要求；专业技术人员收集信息的行为非常普遍，相互的信息网络也极为密切；许多技术性工作需要团队共同完成，所以培养合作精神非常重要；专业技术人员愿意使用专业知识来帮助他人解决问题；杰出的技术人员会专注研究方案以满足“客户”的需要。'},
        {'title':'业务人员','text':'对业务人员来说，最重要的能力是成就和行动类的能力，影响他人占据业务人员的大部分工作时间，所以影响力是杰出业务人员的重要指标；但成就导向的重要性也不亚于影响力，成就动机对于业务人员来说非常重要；人际理解是影响力发挥的基础；自信心是业务人员最重要的个人特质；关系建立一直是业务人员的重要工作；对长周期的技术性商品的销售人员来说，分析式思考也是必备的能力；销售人员需要在和他人的互动中发现固定形式或一致性；业务人员需要寻求有关产品、顾客、潜在顾客、以及竞争对手的相关信息；对长周期技术性销售工作者来说，技术性知识是一个门槛。'},
        {'title':'人类服务工作者','text':'人类服务工作者的范畴很广，杰出的人类服务工作者比较倾向有“协助他人”的动机，包括适度的成就动机、高度喜欢与人接触，以及适度的权力动机。服务工作者需要向服务对象展现出影响力（如老师对学生的影响）；教师与护士都需要完整的培养他人的能力；人际理解是人类服务的重要因素也是影响力的基础；优秀的人类服务者（如老师）给人自信的印象；自我控制力对人类服务工作者很重要，特别是他们面对危机、气愤或沮丧的对象时。'},
        {'title':'管理人员','text':'好的管理者会使用合理的影响力来改善组织的运作；对于管理者来说，成就导向包括评估绩效、设定目标，为部属或团队计算利益；团队合作精神是管理者的重要能力，通常是对团队成员使用的；对杰出的领导者来说，逻辑思考是重要特质；好的管理者需要在个人的工作职责之外，把握住好的机会为未来的问题或机会做准备；培养他人是好的管理者的必备能力；管理者需要对自己的能力和判断力有信心，勇于接受挑战性的任务；管理者要了解他人的态度、观点、情绪等，知道哪些东西可以激励他人，了解团队成员的长处和短处；在某些情况下，管理者果断下命令很重要；管理者需要收集信息以诊断和解决问题；好的管理者能够为团队向组织争取利益和资源；管理者可以找到他人看不出来的关连或形态，在复杂情况下找出关键问题。'}
      ],
      productImg:true,
      dataUrl:''
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo
    })
  },
  created() {
    setWechatTitle('生涯驿站-生涯档案')
    this.getReport()
  },
  methods:{
    // 点击菜单导航跳转到对应位置
    goAnchor(selector) {
      let index = selector.substr(selector.length-1,selector.length)
      this.selectTab(index)
      let anchor = this.$el.querySelector(selector)
      document.documentElement.scrollTop = (anchor.offsetTop-135)
    },
    // 取消图片生成
    cancleSave() {
      this.show = false
    },
    // 确定生成图片
    ExportSavePdf() {
      this.show = true
    },
    // 生成图片
    exportSaveImg() {
      document.querySelector('.head-box').setAttribute('style','position:relative')
      document.querySelector('.r-content').setAttribute('style','margin-top:0px')
      document.documentElement.scrollTop = 0
      this.show=false
      // 生成图片
      this.saveImg(document.querySelector('#demo'))
    },
    // 生成图片链接
    saveImg(ele) {
      let contentWidth = ele.clientWidth // 获得该容器的宽
      let contentHeight = ele.clientHeight // 获得该容器的高
      let canvas = document.createElement('canvas')
      let scale = 1  // 解决清晰度问题，先放大 2倍
      canvas.width = contentWidth * scale // 将画布宽&&高放大两倍
      canvas.height = contentHeight * scale
      canvas.getContext('2d').scale(scale, scale)
      let opts = {
        proxy: '/lib/html2canvas/html2canvasproxy.php',//跨域支持
        scale:scale,
        allowTaint: false, // 支持跨域
        canvas: canvas,
        width: contentWidth,
        height: contentHeight,
        useCORS: true
      }
      return html2canvas(ele,opts).then(canvas => {
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        this.dataUrl = pageData
        this.productImg = false
      })
    },
    // 返回报告页
    BackReport() {
      this.productImg = true
    },
    // 获取报告内容
    getReport() {
      const options = {
        method: 'post',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({
          openId: this.shengyaUser.openid
        }),
        url:'/cob/cosReport.do'
      }
      axios(options)
      .then((response)=>{
        if(response.data.result.success) {
          let result = response.data.data
          if(result) {
            this.result=result
          }
        }else{
          this.$store.commit('showMessage', {
            message: response.data.result.message,
            type: 'warn'
          })
        }
      })
      .catch((error)=>{
        console.warn(error)
      })
    },
    // 点击选择菜单项
    selectTab(num) {
      let self = this
      self.isCurrent.map(function(item,index) {
        if(item) {
          self.$set(self.isCurrent,index,false)
        }
      })
      self.$set(self.isCurrent,num,true)
    },
    //返回广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
      this.$bus.$emit('back-activities')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .head-box
    position:fixed
    top:0
    width:100%
    max-width:600px
    background-color:#f9f9f9
  .head-content
    overflow:hidden
    margin: 0 10px
    .left-img
      float:left
      width:60px
      height:60px
      border-radius:50%
      margin-top:20px
    .center-area
      float:left
      font-size:12px
      margin-top:15px
      p
        margin:5px
        line-height:15px
      .head-title
        font-size:18px
  .right-area
    margin:20px 10px
    position: fixed
    top: 0
    right: 0
    z-index:1
    .danger
      background-color:#fb8d3e
      color:#ffffff
      border:none
    .el-button:active,.el-button:hover
      border-color:transparent
  .big-title
    font-size:20px
    text-align:center
    margin:10px
    background-color: #8BC34A
    color:#FFFFFF
    padding:10px
  .nav-menu
    overflow:hidden
    margin:10px
    border-bottom:3px solid #bbbbbb
    li
      float:left
      background-color:#fb8d3e
      margin:2px
      padding:3px
      font-size:12px
      border:1px solid #bbbbbb
      margin-bottom:-3px
      color:#ffffff
    .current
      background-color:#eb744b
  .report-img
    width:98%
    border:3px solid #bbbbbb
    margin-bottom:1rem
  .r-content
    margin-top:130px
    padding-bottom:50px
  .modal-box
    z-index:2
  .modal-content
    .btn-group
      margin:0 0 0 0.5rem
      .default-btn
        width:45%
        display:inline-block
      .submit-btn
        margin-left:0.3rem
</style>
